import { Link } from 'react-router-dom';

import { getInfo, TruncateWithTooltipFormatter } from '@Components/Grid/components/Table/formatters';

export default function PublisherLinkFormatter({ info }) {
  const { row } = getInfo(info)
  const { id, name } = row.publisher || {}
  if (id && name) {
    return <>
      <Link className='twy-text-base-accent hover:underline' to={`/offer/publishers/${id}`}>
        <TruncateWithTooltipFormatter value={`[#${id}] - ${name}`} />
      </Link>
    </>
  }

  return '--'
}
